import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const startScheduledCheckoutAbTest = {
  name: "startScheduledCheckoutAbTest" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.null(),
};
